import PropTypes from 'prop-types';

export const AssociatedContentItem = PropTypes.shape({
  archived_at: PropTypes.string,
  assigned_at: PropTypes.string,
  association_id: PropTypes.number.isRequired,
  id: PropTypes.number.isRequired,
  overview_url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
});

export const AssociatedContentItems = PropTypes.arrayOf(AssociatedContentItem);

export const AssociatedContentItemsError = PropTypes.shape({
  associationId: PropTypes.number.isRequired,
  error: PropTypes.shape({}).isRequired,
});

export const AssociatedContentItemsErrors = PropTypes.arrayOf(
  AssociatedContentItemsError,
);

export const AssociatedContent = PropTypes.shape({
  contentItems: AssociatedContentItems,
  contentItemErrors: AssociatedContentItemsError,
  loading: PropTypes.bool,
  error: PropTypes.string,
});
